import { createSlice } from '@reduxjs/toolkit';
import { EmployeelogState , Employeelog } from './employeelog.Types';
import { fetchAllEmployeelog , fetchAllEmployeelogById } from './employeelog.Action';
const initialState : EmployeelogState ={
    employeelog : [],
    selectedemployeelog : undefined,
    loadingStates : {
        create: false,
        update: false,
        delete: false,
        fetchById: false,
        fetchAll: false,
    },
    errors: {
        create: undefined,
        update: undefined,
        delete: undefined,
        fetchById: undefined,
        fetchAll: undefined,
    },
}


const  employeelogSlice = createSlice ({
    name : 'employeelog' ,
    initialState,
    reducers:{},
    extraReducers : (builder) =>{
        builder           
               .addCase(fetchAllEmployeelogById.pending, (state) => {
                                   state.loadingStates.fetchById = true;
                                   state.errors.fetchById = undefined;
                               })
                               .addCase(fetchAllEmployeelogById.fulfilled, (state, action) => {
                                   state.loadingStates.fetchById = false;
                                   state.selectedemployeelog = action.payload;
                               })
                               .addCase(fetchAllEmployeelogById.rejected, (state, action) => {
                                   state.loadingStates.fetchById = false;
                                   state.errors.fetchById = action.payload as string;
                               })
                   
                               // Fetch All 
                               .addCase(fetchAllEmployeelog.pending, (state) => {
                                   state.loadingStates.fetchAll = true;
                                   state.errors.fetchAll = undefined;
                               })
                               .addCase(fetchAllEmployeelog.fulfilled, (state, action) => {
                                   state.loadingStates.fetchAll = false;
                                   state.employeelog = action.payload.data;
                               })
                               .addCase(fetchAllEmployeelog.rejected, (state, action) => {
                                   state.loadingStates.fetchAll = false;
                                   state.errors.fetchAll = action.payload as string;
                               }); 
    }
})

export default employeelogSlice.reducer;